export class ResponseError extends Error {
    constructor(response, message) {
        super(message);
        this.response = response;
        Object.setPrototypeOf(this, ResponseError.prototype);
    }
    getResponse() {
        return this.response;
    }
}
